import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RemoveFromQueueIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remove_from_queue"}/>
}
